import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
export const Projects = () => {
  const [filter, setFilter] = useState('all');
  const projects = [{
    id: 1,
    title: 'Dredget Job Listing App',
    category: 'mobile',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKxFGwAJZP6XrGP9wFrwHX/0shots_solll.png',
    description: 'A real-time job listing mobile application that connects users with local job opportunities. Features include job posting, searching, and instant messaging.'
  }, {
    id: 2,
    title: 'Dredget Marketing Website',
    category: 'web',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/suzZ4AqWeYLAm4m6237K6P/2B2B2B98.png',
    description: 'Responsive marketing website for the Dredget mobile application, showcasing features and driving app downloads through strategic call-to-actions.'
  }, {
    id: 3,
    title: 'Dredget Admin Dashboard',
    category: 'web',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gnWbTCdueQNDNp57FvRd5R/667_3x_shots_so.png',
    description: 'Comprehensive admin dashboard for managing job listings, user accounts, and analytics for the Dredget platform.'
  }, {
    id: 4,
    title: 'Dredget Mobile Map Interface',
    category: 'mobile',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eeSWkJ3ccUxeHDGRQefHjv/457shots_so.png',
    description: 'Location-based job search interface allowing users to find opportunities near them with an intuitive map-based experience.'
  }, {
    id: 5,
    title: 'Dredget Messaging System',
    category: 'mobile',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rnk8rZ5Tyk8xcGpbNeNaVD/IMG_8552.png',
    description: 'In-app messaging system enabling direct communication between job seekers and employers for a seamless hiring process.'
  }, {
    id: 6,
    title: 'Dredget Brand Identity',
    category: 'web',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nrvKveWXboUtKioCJSAtxi/15.jpg',
    description: 'Comprehensive brand identity system for Dredget including logo design, color palette, typography, and visual language.'
  }, {
    id: 7,
    title: 'Dredget Billboard Campaign',
    category: 'branding',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1cjSt4igEiwSFUFycSRTH6/Scene__11.png',
    description: 'Outdoor advertising campaign for Dredget featuring striking visuals and compelling messaging to attract new users to the platform.'
  }, {
    id: 8,
    title: 'Kong Wear E-commerce App',
    category: 'mobile',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pdrnQV8efffAMij5gQnx4Q/maja_nool_3.png',
    description: 'Fashion e-commerce mobile application with a bold design language, featuring product showcases, personalized recommendations, and seamless checkout experience.'
  }, {
    id: 9,
    title: 'Dredget Mobile UI Redesign',
    category: 'mobile',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g61LqwjFgQVf9kfTR32XKX/dbdbdbb.jpg',
    description: 'Complete UI redesign for the Dredget mobile application with improved usability, visual hierarchy, and engagement metrics.'
  }, {
    id: 10,
    title: 'Architectural Visualization',
    category: 'branding',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6c45mKjbBLgQDgW5KThDJ6/680shots_soij.png',
    description: 'Minimalist architectural visualization project highlighting structural elements with a focus on form, light, and shadow.'
  }, {
    id: 11,
    title: 'Dredget Marketing Campaign',
    category: 'branding',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/us77NzGULfuwUpjpLVfRhr/2B2B2B98dddd.png',
    description: 'Integrated marketing campaign for Dredget featuring cohesive visual identity across digital and print media to increase brand awareness.'
  }];
  const filteredProjects = filter === 'all' ? projects : projects.filter(project => project.category === filter);
  return <section id="projects" className="py-20 bg-white" data-id="element-145">
      <div className="container mx-auto px-4 md:px-6" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-148">My Projects</h2>
          <div className="w-20 h-1 bg-indigo-600 mx-auto mb-6" data-id="element-149"></div>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-150">
            A selection of my recent work across various industries and
            platforms.
          </p>
        </div>
        <div className="flex justify-center mb-10" data-id="element-151">
          <div className="flex flex-wrap gap-2 md:gap-4 justify-center" data-id="element-152">
            {['all', 'web', 'mobile', 'branding'].map(category => <button key={category} onClick={() => setFilter(category)} className={`px-5 py-2 rounded-full capitalize transition-colors ${filter === category ? 'bg-indigo-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-800'}`} data-id="element-153">
                {category === 'all' ? 'All Projects' : `${category} Design`}
              </button>)}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-154">
          {filteredProjects.map(project => <div key={project.id} className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow" data-id="element-155">
              <div className="relative overflow-hidden" data-id="element-156">
                <img src={project.image} alt={project.title} className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-157" />
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-158">
                  <a href="#" className="bg-white text-indigo-600 p-3 rounded-full transform translate-y-4 group-hover:translate-y-0 transition-transform" aria-label={`View ${project.title} details`} data-id="element-159">
                    <ExternalLink size={20} data-id="element-160" />
                  </a>
                </div>
              </div>
              <div className="p-6" data-id="element-161">
                <h3 className="text-xl font-bold mb-2" data-id="element-162">{project.title}</h3>
                <p className="text-gray-600 mb-4" data-id="element-163">{project.description}</p>
                <div className="flex items-center" data-id="element-164">
                  <span className="text-xs uppercase tracking-wider bg-indigo-100 text-indigo-800 px-2 py-1 rounded" data-id="element-165">
                    {project.category === 'web' ? 'Web Design' : project.category === 'mobile' ? 'Mobile App' : 'Branding'}
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};